import { Accordion, AccordionDetails, AccordionSummary, Box, MenuItem, Typography } from '@mui/material'
import { icons } from '../../../constants/images'
import ButtonCustom from '../../../component/button/buttonCustom'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InputTextField from '../../../component/input/inputTextField';
import FilterSelect from '../../../component/select/filterSelect';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import React from 'react';
import { LayoutTitle, LayoutView, TitleText } from '../../../component/layout/layoutMainStyle';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

export default function CreateMyDocuments() {
    const [value, setValue] = React.useState<number>(1);

    const handleChange = (event: any, newValue: any) => {
        setValue(newValue);
    };
    return (
        <LayoutView>
            <LayoutTitle>
                <TitleText>สร้างตู้เอกสาร</TitleText>
                <div style={{ display: 'flex' }}>
                    <ButtonCustom variant={'outlined'}
                        startIcon={<icons.security1 />}
                        textButton={'การเข้าถึงตู้เอกสาร'}
                        onClick={() => { }}
                        style={{ marginRight: '8px' }}
                        btnStyle={{
                            '&.MuiButton-outlined': {
                                color: `#0A77FF !important`,
                                border: `2px solid #0A77FF !important`,
                                borderRadius: "10px !important",
                                '&:hover': {
                                    color: `#0A77FF  !important`,
                                    border: `2px solid #0A77FF !important`,
                                    backgroundColor: '#EFFFF7 !important'
                                },
                            },
                        }} />
                    {/* <ButtonCustom variant={'outlined'}
                    endIcon={<icons.downloadButton />}
                    textButton={'สร้างตู้เอกสาร'}
                    onClick={() => { }} 
                    style={{marginRight:'8px'}}
                    btnStyle={{
                        '&.MuiButton-outlined': {
                            color: `#323539 !important`,
                            border: `2px solid #E5E5E7 !important`,
                            borderRadius: "10px !important",
                            '&:hover': {
                                color: `#323539  !important`,
                                border: `2px solid #E5E5E7 !important`,
                                backgroundColor: '#EFFFF7 !important'
                            },
                        },
                    }}/>
                     */}
                    <ButtonCustom variant={'outlined'}
                        textButton={'บันทึก'}
                        onClick={() => { }}
                        btnStyle={{
                            '&.MuiButton-outlined': {
                                color: `#fff !important`,
                                border: `2px solid #026735 !important`,
                                borderRadius: "10px !important",
                                backgroundColor: '#026735 !important',
                                '&:hover': {
                                    color: `#fff  !important`,
                                    border: `2px solid #026735 !important`,
                                    backgroundColor: '#026735 !important'
                                },
                            },
                        }} />
                </div>

            </LayoutTitle>
            <Accordion sx={{
                boxShadow: 'none', ':before': {
                    content: '""',
                    height: "0px"
                }
            }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography>รายละเอียดตู้เอกสาร</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <InputTextField heading='ชื่อตู้เอกสาร*' />
                        <InputTextField heading='สถานที่จัดเก็บ*' />
                        <div>
                            <FilterSelect style={{ width: '112px' }} heading='ระยะเวลาเอกสาร*' labelId='' selectId='' options={[{ value: '-', name: '-' },].map((x, i) => {
                                return (
                                    <MenuItem key={i}
                                        value={x.value}
                                    >
                                        {x.name}
                                    </MenuItem>
                                )
                            })} value={'-'} onchange={(e: any) => { }} />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: "32px" }}>

                            <div style={{ display: 'flex' }}>
                                <ButtonCustom variant={'outlined'}
                                    startIcon={<icons.security1 />}
                                    textButton={'การเข้าถึงชั้นเอกสาร'}
                                    onClick={() => { }}
                                    style={{ marginRight: '8px' }}
                                    btnStyle={{
                                        '&.MuiButton-outlined': {
                                            color: `#0A77FF !important`,
                                            border: `2px solid #0A77FF !important`,
                                            borderRadius: "10px !important",
                                            '&:hover': {
                                                color: `#0A77FF  !important`,
                                                border: `2px solid #0A77FF !important`,
                                                backgroundColor: '#EFFFF7 !important'
                                            },
                                        },
                                    }} />
                                <ButtonCustom variant={'outlined'}
                                    endIcon={<icons.downloadButton />}
                                    textButton={'ดาวน์โหลดชั้นเอกสาร'}
                                    onClick={() => { }}
                                    btnStyle={{
                                        '&.MuiButton-outlined': {
                                            color: `#323539 !important`,
                                            border: `2px solid #E5E5E7 !important`,
                                            borderRadius: "10px !important",
                                            '&:hover': {
                                                color: `#323539  !important`,
                                                border: `2px solid #E5E5E7 !important`,
                                                backgroundColor: '#EFFFF7 !important'
                                            },
                                        },
                                    }} />


                            </div>

                        </div>
                        <div>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: "end" }}>
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    allowScrollButtonsMobile
                                    aria-label="scrollable force tabs example"
                                    sx={{
                                        '& .MuiTabs-indicator': {
                                            display: 'none',
                                        }, '& .MuiTabs-scrollButtons': {
                                            color: 'background.BlueBL',
                                        }
                                    }}
                                >
                                    <Tab label="ชั้นเอกสารที่ 1 " sx={{
                                        '&.Mui-selected': {
                                            background: '#026735',
                                            color: '#fff'
                                        }
                                    }} />
                                    <Tab label="ชั้นเอกสารที่ 1 " sx={{
                                        '&.Mui-selected': {
                                            background: '#026735',
                                            color: '#fff'
                                        }
                                    }} />
                                    <Tab label="ชั้นเอกสารที่ 1 " sx={{
                                        '&.Mui-selected': {
                                            background: '#026735',
                                            color: '#fff'
                                        }
                                    }} />


                                </Tabs>

                                <ButtonCustom textButton={'บันทึก'}
                                    onClick={() => { }}
                                    startIcon={<icons.addLayer />}
                                    btnStyle={{
                                        '&.MuiButton-contained': {
                                            borderRadius: "0px !important",
                                            color: `#026735 !important`,
                                            backgroundColor: '#EFFFF7 !important',
                                            '&:hover': {
                                                color: `#026735  !important`,
                                                backgroundColor: '#EFFFF7 !important'
                                            },
                                        },
                                    }} />
                            </Box>
                            <div style={{ width: '100%', padding: '12px', background: "#F8F9FB", height: "100vh" }}>
                                <CustomTabPanel value={value} index={0}>
                                    <div style={{ display: 'flex', marginBottom: "32px" }}>
                                        <div>
                                            <Tabs
                                                value={value}
                                                onChange={handleChange}
                                        
                                                aria-label="scrollable force tabs example"
                                                sx={{
                                                    '& .MuiTabs-indicator': {
                                                        display: 'none',
                                                    }, '& .MuiTabs-scrollButtons': {
                                                        color: 'background.BlueBL',
                                                    }
                                                }}
                                            >
                                                <Tab label="ชั้นเอกสารที่ 1 " sx={{
                                                    '&.Mui-selected': {
                                                        background: '#026735',
                                                        color: '#fff'
                                                    }
                                                }} />
                                                <Tab label="ชั้นเอกสารที่ 1 " sx={{
                                                    '&.Mui-selected': {
                                                        background: '#026735',
                                                        color: '#fff'
                                                    }
                                                }} />
                                             

                                            </Tabs>
                                        </div>
                                        <div style={{ width:'100%',display: 'flex', justifyContent:'flex-end' }}>
                                            <ButtonCustom variant={'outlined'}
                                                startIcon={<icons.security1 />}
                                                textButton={'การเข้าถึงชั้นเอกสาร'}
                                                onClick={() => { }}
                                                style={{ marginRight: '8px' }}
                                                btnStyle={{
                                                    '&.MuiButton-outlined': {
                                                        color: `#0A77FF !important`,
                                                        border: `2px solid #0A77FF !important`,
                                                        borderRadius: "10px !important",
                                                        '&:hover': {
                                                            color: `#0A77FF  !important`,
                                                            border: `2px solid #0A77FF !important`,
                                                            backgroundColor: '#EFFFF7 !important'
                                                        },
                                                    },
                                                }} />
                                            <ButtonCustom variant={'outlined'}
                                                endIcon={<icons.downloadButton />}
                                                textButton={'ดาวน์โหลดประเภทเอกสาร'}
                                                onClick={() => { }}
                                                btnStyle={{
                                                    '&.MuiButton-outlined': {
                                                        color: `#323539 !important`,
                                                        border: `2px solid #E5E5E7 !important`,
                                                        borderRadius: "10px !important",
                                                        backgroundColor: '#FFF !important',
                                                        '&:hover': {
                                                            color: `#323539  !important`,
                                                            border: `2px solid #E5E5E7 !important`,
                                                            backgroundColor: '#EFFFF7 !important'
                                                        },
                                                    },
                                                }} />


                                        </div>

                                    </div>
                                </CustomTabPanel>

                            </div>
                        </div>

                    </div>
                </AccordionDetails>
            </Accordion>
        </LayoutView>
    )
}
